import styled from "styled-components";
import React from "react";
import { EvidenceIcon } from "./EvidenceIcon";

export function RuledOutEvidence({
  ruledOutEvidence,
  onRuledOutEvidenceClicked,
  selectedEvidence,
  evidenceNeededForSuggestions,
}) {
  const evidenceTypes = [
    "EMF Level 5",
    "Ghost Orbs",
    "Ghost Writing",
    "Freezing Temperatures",
    "Spirit Box",
    "Fingerprints",
    "D.O.T.S Projector",
  ];
  const remainingEvidence = evidenceTypes.filter(
    (evidence) => !selectedEvidence.includes(evidence)
  );
  return (
    <EvidencePanel>
      <HeaderLayout>
        <Header>Rule Out Evidence:</Header>
      </HeaderLayout>
      <EvidenceOptionList>
        {remainingEvidence.map((evidence, i) => (
          <EvidenceOption
            key={i}
            onClick={(e) => {
              const selectedEvidence = evidence;
              onRuledOutEvidenceClicked(selectedEvidence);
            }}
            selected={ruledOutEvidence.includes(evidence)}
          >
            <StyledEvidenceIcon evidence={evidence} />
            <TextLabel>{evidence}</TextLabel>
          </EvidenceOption>
        ))}
      </EvidenceOptionList>
    </EvidencePanel>
  );
}
export const StyledEvidenceIcon = styled(EvidenceIcon)`
  margin-left: auto;
  @media (max-width: 750px) {
    margin-right: auto;
  }
`;
const TextLabel = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  margin-right: auto;
  @media (max-width: 750px) {
    visibility: hidden;
    margin: 0px;
    width: 0px;
    height: 0px;
  }
`;

const Header = styled.div`
  font-size: 18px;
  margin-right: auto;
  margin-left: 5px;
`;

const HeaderLayout = styled.div`
  display: flex;
`;

const EvidenceOption = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
  padding: 15px;
  background: ${(props) => (props.selected ? "#ac5151" : "transparent")};
  :hover& {
    background: #5181ac;
  }
  @media (max-width: 750px) {
    padding: 3px;
    margin: 0px;
  }
`;
const EvidencePanel = styled.div`
  border: 1px solid #5181ac;
  margin: 25px;
  @media (max-width: 750px) {
    margin: 10px;
  }
`;
const EvidenceOptionList = styled.div`
  overflow: auto;
  display: flex;
  @media (max-width: 750px) {
    overflow: hidden;
  }
`;
